module.exports = "<fw-loader> </fw-loader>\r\n<router-outlet>\r\n\r\n</router-outlet>\r\n\r\n<div kendoDialogContainer></div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/app.component.html
// module id = 2305
// module chunks = 1